import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SentInvitations from "../../Components/Invitations/Sent/Sent";
import ReceivedInvitations from "../../Components/Invitations/Received/Received";
import ResponsiveSent from "../../Components/Invitations/Responsive/Sent-Tab";
import ResponsiveReceived from "../../Components/Invitations/Responsive/Received-Tab";
import Popover from "../../Components/PopOver/Popover";
import MyInvitationsIcon from "../../../images/new-images/MyinvitationsImg.png";
import info_black_24dp from "../../../images/info_black_24dp.png";
import "./My-Invitations.css";
import Renderpopoverinnercontent from "./popover-inner-content";

const Myinvitations = (props) => {
  const calcWidth = window.innerWidth;
  const ReceivedTab = ({ children }) => (
    <Tab>
      <div
        className={props.receivedTab ? "activeTab" : ""}
        onClick={props.handleReceivedTab}
      >
        {children}
      </div>
    </Tab>
  );
  ReceivedTab.tabsRole = "Tab";

  const SentTab = ({ children }) => (
    <Tab>
      <div
        className={props.sentTab ? "activeTab" : ""}
        onClick={props.handleSentTab}
      >
        {children}
      </div>
    </Tab>
  );
  SentTab.tabsRole = "Tab";

  return (
    <React.Fragment>

      {calcWidth <= 767 && <div className="header ResponsiveDashboardcardlayoutHeader d-flex mb-3">
        <img
          className="headerIcon responsiveHeaderIcon"
          src={MyInvitationsIcon}
          alt="dashboard icon"
        />
        <h1 className="headerText mb-0">My Invitations</h1>
        <Popover
          className="Invitation-popover"
          positions={["top"]}
          align={"center"}
          targtElement={
            <img
              src={info_black_24dp}
              alt="info icon"
              style={{ marginLeft: "10px", width: "20px", cursor: "pointer" }}
            />
          }
          isOpen={props.isPopOverVisible}
          setOpen={props.handleInvitationPopOver}
        >
          <Renderpopoverinnercontent
            handleCloseInvitationsPopOver={
              props.handleCloseInvitationsPopOver
            }
          />
        </Popover>
      </div>}
      <section className="dashboard-wrapper">
        <div className="card-layout responsive-invitation-layout">
          {calcWidth > 767 && <div className="header">
            <img
              className="headerIcon"
              src={MyInvitationsIcon}
              alt="dashboard icon"
            />
            <h1 className="headerText">My Invitations</h1>
            <Popover
              className="Invitation-popover"
              positions={["top"]}
              align={"center"}
              targtElement={
                <img
                  src={info_black_24dp}
                  alt="info icon"
                  style={{ marginLeft: "10px", width: "20px", cursor: "pointer" }}
                />
              }
              isOpen={props.isPopOverVisible}
              setOpen={props.handleInvitationPopOver}
            >
              <Renderpopoverinnercontent
                handleCloseInvitationsPopOver={
                  props.handleCloseInvitationsPopOver
                }
              />
            </Popover>
          </div>}
          {props.overlayIsVisible && <div className="overlay"></div>}
          <Tabs>
            <TabList>
              <ReceivedTab>Received</ReceivedTab>
              <div className="Line"></div>
              <SentTab>Sent</SentTab>
            </TabList>

            <TabPanel>
              {calcWidth <= 767 ? (
                <ResponsiveReceived
                  receivedInvitations={props.receivedInvitations}
                  collapseID={props.collapseID}
                  toggleCollapse={props.toggleCollapse}
                />
              ) : (
                <div className="my-invitation-table">
                  <ReceivedInvitations
                    receivedInvitations={props.receivedInvitations}
                  />
                </div>
              )}
            </TabPanel>
            <TabPanel>
              {calcWidth <= 767 ? (
                <ResponsiveSent
                  sentRespondants={props.sentRespondants}
                  editModal={props.editModal}
                  deleteModal={props.deleteModal}
                  handleModalClose={props.handleModalClose}
                  handleEditModal={props.handleEditModal}
                  handleDeleteModal={props.handleDeleteModal}
                  respondentEmail={props.respondentEmail}
                  respondentRelationship={props.respondentRelationship}
                  handleInvitationsModal={props.handleInvitationsModal}
                  respondentInvitationsModal={props.respondentInvitationsModal}
                  inputFields={props.inputFields}
                  dropDownOptions={props.dropDownOptions}
                  isChecked={props.isChecked}
                  isDisabled={props.isDisabled}
                  handleInputFields={props.handleInputFields}
                  handleMultipleEmail={props.handleMultipleEmail}
                  getRespondantStatus={props.getRespondantStatus}
                  getUrlString={props.getUrlString}
                  minRespondants={props.minRespondants}
                  batchMinRespondants={props.batchMinRespondants}
                  handleReminder={props.handleReminder}
                  respondantUserAssessmentId={props.respondantUserAssessmentId}
                  respondantIndividualId={props.respondantIndividualId}
                  handleDeleteRequest={props.handleDeleteRequest}
                  filteredSentRespondants={props.filteredSentRespondants}
                  sentRespondantsId={props.sentRespondantsId}
                  sentRespondantsFilteredId={props.sentRespondantsFilteredId}
                  assessmentUserId={props.assessmentUserId}
                  accessorGroupId={props.accessorGroupId}
                  relationShipId={props.relationShipId}
                  handleDropdownOptions={props.handleDropdownOptions}
                  collapseID={props.collapseID}
                  toggleCollapse={props.toggleCollapse}
                  handleUnfilteredEditModalSubmit={
                    props.handleUnfilteredEditModalSubmit
                  }
                  handleEditModalSubmit={props.handleEditModalSubmit}
                />
              ) : (
                <div className="my-invitation-table">
                  <SentInvitations
                    editModal={props.editModal}
                    deleteModal={props.deleteModal}
                    handleEditModal={props.handleEditModal}
                    handleDeleteModal={props.handleDeleteModal}
                    respondentEmail={props.respondentEmail}
                    respondentRelationship={props.respondentRelationship}
                    sentRespondants={props.sentRespondants}
                    handleInvitationsModal={props.handleInvitationsModal}
                    respondentInvitationsModal={props.respondentInvitationsModal}
                    inputFields={props.inputFields}
                    dropDownOptions={props.dropDownOptions}
                    isChecked={props.isChecked}
                    isDisabled={props.isDisabled}
                    handleInputFields={props.handleInputFields}
                    handleMultipleEmail={props.handleMultipleEmail}
                    getRespondantStatus={props.getRespondantStatus}
                    getUrlString={props.getUrlString}
                    minRespondants={props.minRespondants}
                    batchMinRespondants={props.batchMinRespondants}
                    handleReminder={props.handleReminder}
                    sentRespondantsId={props.sentRespondantsId}
                    handleModalClose={props.handleModalClose}
                    assessmentUserId={props.assessmentUserId}
                    accessorGroupId={props.accessorGroupId}
                    relationShipId={props.relationShipId}
                    handleDropdownOptions={props.handleDropdownOptions}
                    handleEditModalSubmit={props.handleEditModalSubmit}
                  />
                </div>
              )}
            </TabPanel>
          </Tabs>
        </div>
      </section>
    </React.Fragment>
  );
};
export default Myinvitations;



// WEBPACK FOOTER //
// ./src/new/Dashboard/My-Invitations/My-Invitations.jsx